import { Button } from '@ads/components-react';
import * as Dialog from '@radix-ui/react-dialog';

export interface ConfirmDialogProps {
  readonly open: boolean;
  readonly title: string;
  readonly body: string;
  readonly confirmLabel: string;
  readonly cancelLabel: string;
  /** Hierarquia do botão de confirmação — `danger` para ações destrutivas. */
  readonly tone?: 'primary' | 'danger';
  readonly onConfirm: () => void;
  readonly onOpenChange: (open: boolean) => void;
}

/**
 * Diálogo de confirmação da feature (Radix Dialog), usado antes de publicar um prompt,
 * remover um arquivo ou sair de uma edição não salva.
 *
 * Controlado por `open`/`onOpenChange`; ao fechar por qualquer caminho (Cancelar, Esc,
 * clique fora) o Radix remove overlay e scroll-lock sem resíduo.
 */
export function ConfirmDialog({
  open,
  title,
  body,
  confirmLabel,
  cancelLabel,
  tone = 'primary',
  onConfirm,
  onOpenChange,
}: ConfirmDialogProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-none z-50 h-screen w-screen bg-base-gray-900 bg-opacity-medium backdrop-blur-soft" />
        <Dialog.Content
          aria-describedby={undefined}
          className="-translate-x-1/2 -translate-y-1/2 fixed top-1/2 left-1/2 z-50 flex w-full max-w-[28rem] flex-col gap-mini rounded-lg bg-ctx-layout-surface p-xxs shadow-level4 focus:outline-none"
        >
          <Dialog.Title className="text-ctx-content-title ts-heading-xs">{title}</Dialog.Title>
          <p className="text-ctx-content-base ts-paragraph-xs">{body}</p>
          <div className="flex justify-end gap-nano">
            <Dialog.Close asChild>
              <Button hierarchy="secondary" size="md">
                {cancelLabel}
              </Button>
            </Dialog.Close>
            <Button
              hierarchy={tone === 'danger' ? 'danger' : 'primary'}
              size="md"
              onClick={onConfirm}
            >
              {confirmLabel}
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
